import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-schedule-of-activities',
  templateUrl: './schedule-of-activities.component.html',
  styleUrl: './schedule-of-activities.component.scss'
})
export class ScheduleOfActivitiesComponent implements OnInit {
  queryParams: any = {}; // To store query parameters

  studyId: string | null = null; // Study ID
  subjectId: string | null = null; // Subject ID
  studyCode: any; // Study Code
  studyName: any; // Study Name
  siteLocation: any; // Site Location
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: any;
  folderName: any;
  subjectName: string | null;
  formName: string = 'Schedule-Activities';
  formData: any[] = [];
  statusOptions: string[] = ['Complete', 'Incomplete', 'Locked', 'Not Applicable'];
  columnNames: string[] = ['BMI Check', 'Clinical Exam', 'HbA1c Test', 'Product Retrieval', 'Product Dispensing'];
  showDiscontinuationComment: boolean = false;

constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {}
 ngOnInit() {
  const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;

    this.informedConsentDate = '';
    this.screeningMinDate = '';

    this.route.params.subscribe(params => {
      this.folderName = params['folderName'] ?? 'schedule-of-activities';
      this.formName = params['formName'];
      console.log("Form Name:", this.formName);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.subjectId = queryParams['subjectId'];
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });
    // Initialize rows based on your screenshot
    this.formData = [
      { visitName: 'Screening Visit', isDiscontinued: false },
      { visitName: 'Baseline Visit', isDiscontinued: false },
      { visitName: 'Follow up Visit 01', isDiscontinued: false },
      { visitName: 'Follow up Visit 02', isDiscontinued: false },
      { visitName: 'Follow up Visit 03', isDiscontinued: false },
      { visitName: 'Follow up Visit 04', isDiscontinued: false },
      { visitName: 'Follow up Visit 05', isDiscontinued: false },
      { visitName: 'Follow up Visit 06', isDiscontinued: false },
      { visitName: 'Follow up Visit 07', isDiscontinued: false },
      { visitName: 'Follow up Visit 08', isDiscontinued: false },
      { visitName: 'Follow up Visit 09', isDiscontinued: false },
      { visitName: 'Follow up Visit 10', isDiscontinued: false },
      { visitName: 'Follow up Visit 11', isDiscontinued: false },
      { visitName: 'Study Completion', isDiscontinued: false },
      { visitName: 'Follow up Visit 12 (post-intervention)', isDiscontinued: false },
    ];
  
  

    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
            if (Array.isArray(response.data)) {
              this.mapFormData(response.data);
            } else {
              console.warn('Form data is not an array or is missing.');
            }
            this.mapStudyDetails(response.studyDetails);
             // Dynamically update informedConsentDate from the response
             if (response.informedConsentDate !== undefined) {
              this.informedConsentDate = response.informedConsentDate;
              this.screeningMinDate = this.informedConsentDate;  // Set min date
              console.log("Informed Consent Date:", this.informedConsentDate);
            } else {
              console.warn('Informed consent date is missing in the response.');
            }
            // Store the gender from the response
          this.gender = response.gender;
          console.log("gender:",this.gender);
          if (response.data) {
            this.mapFormData(response.data); // Ensure data mapping happens AFTER gender is set
        }
          }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
    } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
  }

  // Function to map study details
  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      this.studyCode = studyDetails.study_code ?? 'N/A';
      this.studyName = studyDetails.study_name ?? 'Unknown Study';
      this.siteLocation = studyDetails.site_location ?? 'Unknown Location';
      this.subjectName = this.subjectId;

      console.log("Mapped Study Details:", {
        studyCode: this.studyCode,
        studyName: this.studyName,
        siteLocation: this.siteLocation,
        subjectName: this.subjectName,
      });
    } else {
      console.warn('Study details are missing or undefined.');
    }
  }
  mapFormData(data: any[]): void {
    console.log("Mapping Schedule-Activities Form Data:", data);
  
    data.forEach(item => {
      const subData = JSON.parse(item.sub_data); // Parse sub_data
  
      // Find the corresponding entry in formData using visitName
      const existingEntry = this.formData.find(entry => entry.visitName === subData.visitName);
  
      if (existingEntry) {
        console.log("Processing Visit Name:", subData.visitName);
  
        // Map activities correctly
        this.columnNames.forEach(column => {
          if (subData.activities && subData.activities.hasOwnProperty(column)) {
            existingEntry[column] = subData.activities[column];
          }
        });
  
        // Handle discontinuation checkbox and comment
        existingEntry.isDiscontinued = subData.isDiscontinued ?? false;
        existingEntry.discontinuationComment = subData.discontinuationComment ?? '';
  
        console.log("Mapped Entry:", existingEntry);
      } else {
        console.warn(`No matching entry found for visitName: ${subData.visitName}`);
      }
    });
  
    // After mapping, update whether to show the Discontinuation Comment input
    this.showDiscontinuationComment = this.formData.some(r => r.isDiscontinued);
  
    console.log("Updated FormData:", this.formData);
  }
  
    
  toggleDiscontinuationComment(row: any) {
    this.showDiscontinuationComment = this.formData.some(r => r.isDiscontinued);
  }

  submitForm() {
    console.log("Before Extracting Schedule-Activities Form Data:", this.formData);
  
    let questionAnswers: { [key: string]: any } = {};
  
    if (this.formName === 'Schedule-Activities' && Array.isArray(this.formData)) {
      this.formData.forEach((item, index) => {
        let fieldKey = `Visit ${index + 1}`;
  
        questionAnswers[fieldKey] = {
          answer: "yes",
          value: {
            visitName: item.visitName,
            activities: this.columnNames.reduce((acc, column) => {
              if (item[column] !== undefined) {
                acc[column] = item[column];
              }
              return acc;
            }, {} as { [key: string]: any }),
            ...(item.isDiscontinued !== undefined && { isDiscontinued: item.isDiscontinued }),
            ...(item.discontinuationComment !== undefined && { discontinuationComment: item.discontinuationComment })
          }
        };
      });
    }
  
    console.log("Submitted Schedule-Activities Data:", questionAnswers);
  
    const submittedData = {
      folderName: this.folderName,
      formName: this.formName,
      studyId: this.studyId,
      subjectId: this.subjectId,
      ...questionAnswers
    };
  
    console.log("Form Submitted:", submittedData);
  
    this.apiService.insertFormData(submittedData).subscribe({
      next: (response) => {
        console.log("Response from API:", response);
        alert("Schedule-Activities Form Submitted Successfully!");
      },
      error: (error) => {
        console.error("Error submitting Schedule-Activities form:", error);
        alert("Error submitting form. Please try again.");
      }
    });
  }
  

  goBack() {
    this.router.navigate(['/study-details', this.studyId]);
  }
}
